import React from "react";
import { Card, Row, Col, Typography, Divider, Tooltip } from "antd";
import {
  CameraOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

interface ReferralCardProps {
  referral: any;
  schemeSelected: any;
  handleDeleteList: any;
  setPreviewDocument: any;
  setDocumentUrl: any
}

const ReferralCard: React.FC<ReferralCardProps> = ({
  referral,
  schemeSelected,
  handleDeleteList,
  setPreviewDocument,
  setDocumentUrl
}) => {
  const isCGHS = schemeSelected?.toLowerCase()?.includes("cghs");

  return (
    <Card
      bordered
      style={{
        borderRadius: 8,
        marginBottom: 2,
        border: "1px solid #AADFFF",
        // cursor: "pointer",
      }}
      bodyStyle={{ padding: "2px 4px" }}
    >
      {/* HEADER */}
      <Row gutter={[4, 4]}>
        <Col span={11}>
          <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            Referral ID
          </Text>
        </Col>

        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            {isCGHS ? "Beneficiary Id" : "Service No."}
          </Text>
        </Col>

        <Col span={5}>
          <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            {"Issued Date"}
          </Text>
        </Col>
      </Row>

      <Row gutter={[4, 4]}>
        <Col span={11}>
          <Text strong style={{ fontSize: 9, color: "#00395E" }}>
            {isCGHS ? referral?.refferenceID : referral?.referralNo}
          </Text>
        </Col>

        <Col span={8}>
          <Text strong style={{ fontSize: 9, color: "#00395E" }}>
            {isCGHS ? referral?.beneficiaryId : referral?.serviceNumber}
          </Text>
        </Col>

        <Col span={5}>
          <Text strong style={{ fontSize: 9, color: "#00395E" }}>
            {referral?.dateIssued || referral?.referralExpiryFrom}
          </Text>
        </Col>
      </Row>

      {/* SECOND ROW */}
      <Row gutter={[4, 4]}>
        <Col span={11}>
          <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            {/* No. of visits */}
            Ref. Type
          </Text>
        </Col>

        <Col span={8}>
          <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            Valid Upto
          </Text>
        </Col>

        <Col span={5}>
        <Text type="secondary" style={{ fontSize: 8, color: "#00395E80" }}>
            Referral
          </Text>
          </Col>
      </Row>

      <Row gutter={[4, 4]}>
        <Col span={11}>
          <Text strong style={{ fontSize: 9, color: "#00395E" }}>
            {/* {referral?.consumedVisits
              ? (referral?.consumedVisits ?? 0) +
                "/" +
                (referral?.noOfVisits ?? 0)
              : "-"} */}
              {referral?.cardType || referral?.referralType || "-"}
          </Text>
        </Col>

        <Col span={8}>
          <Text strong style={{ fontSize: 9, color: "#00395E" }}>
            {referral?.referralExpiryTo || "-"}
          </Text>
        </Col>

          <Col span={5}>
            <EyeOutlined
              style={{
                fontSize: "8px",
              }}
              onClick={() => {
                setPreviewDocument(true);
                setDocumentUrl(referral?.documentUrl || referral?.documentPath);
              }}
            />
            <Tooltip title="DELETE">
              <DeleteOutlined
                style={{
                  marginLeft: "10px",
                  fontSize: "8px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteList({...referral, id: referral?.documentId}, "referral");
                }}
              />
            </Tooltip>
          </Col>
      </Row>

      {/* SERVICES */}
      {referral?.services?.length > 0 && (
        <>
          <Divider style={{ margin: 0 }} />
          <Row gutter={[4, 4]} style={{ marginBottom: 2 }}>
            <Col span={12}>
              <Text strong style={{ fontSize: 8, color: "#00395E80" }}>
                Service
              </Text>
            </Col>

            <Col span={7}>
              <Text strong style={{ fontSize: 8, color: "#00395E80" }}>
                Type
              </Text>
            </Col>

            <Col span={5}>
              <Text strong style={{ fontSize: 8, color: "#00395E80" }}>
                Valid Upto
              </Text>
            </Col>
          </Row>

          {referral?.services?.map((service: any, index: number) => (
            <Row gutter={[4, 4]} key={index}>
              <Col span={12}>
                <Text style={{ fontSize: 9, color: "#00395E" }}>
                  {service?.name}
                </Text>
              </Col>

              <Col span={7}>
                <Text style={{ fontSize: 9, color: "#00395E" }}>
                  {service?.referralType}
                </Text>
              </Col>

              <Col span={5}>
                <Text style={{ fontSize: 9, color: "#00395E" }}>
                  {service?.validUpto}
                </Text>
              </Col>
            </Row>
          ))}
        </>
      )}
    </Card>
  );
};

export default ReferralCard;
